import React from 'react'

const FunctionComponent = (props) => {
    const keydownHandler = (event) => {
        let charCode = String.fromCharCode(event.which).toLowerCase();
        if(event.ctrlKey && charCode === 's') {
            event.preventDefault();
            props.handleSubmit();
        }
    };
    
    React.useEffect(() => {
        document.addEventListener('keydown', keydownHandler);
        return () => {
            document.removeEventListener('keydown', keydownHandler);
        }
    }, [])
}

export default FunctionComponent;